import { FC } from 'react'
import IconWrapper, { IconWrapperProps } from './IconWrapper'
import { ReactComponent as MySoundOff } from './img/sound-off.svg'

type SoundOffProps = IconWrapperProps

export const SoundOffIcon: FC<SoundOffProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MySoundOff />
    </IconWrapper>
  )
}
